import { render, staticRenderFns } from "./JoppdBIndex.vue?vue&type=template&id=26740aed&scoped=true"
import script from "./JoppdBIndex.vue?vue&type=script&lang=js"
export * from "./JoppdBIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26740aed",
  null
  
)

export default component.exports